import { StateCreator } from "zustand";
import { NavigationState, ParamsState, GlobalParams } from "../types";

export const createParamsSlice: StateCreator<
  NavigationState,
  [],
  [],
  ParamsState
> = (set) => ({
  paymentResult: "cancel",
  accessId: "",
  screenName: undefined,
  artistId: undefined,
  collectionId: undefined,
  collectionType: "album",
  songId: undefined,
  reload: undefined,

  onParamsChange: (_params: GlobalParams) => {
    set(() => {
      const params = _params as Omit<ParamsState, "onParamsChange">;
      return {
        paymentResult: params.paymentResult,
        accessId: params.accessId,
        screenName: params.screenName,
        artistId: params.artistId,
        collectionId: params.collectionId,
        collectionType: params.collectionType,
        songId: params.songId,
        reload: params.reload,
      };
    });
  },
});
